import React from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import Container from '../PageBuilder/lib/Container';
import Img from '../PageBuilder/lib/Image';
import List from '../PageBuilder/List';
import ImagePicker from '../PageBuilder/pickers/ImagePicker/ImagePicker';
import TextInput from '../PageBuilder/forms/TextInput';

const GalleryWidget = ({ list, containerSettings }) => (
  <Container className="gallery" settings={containerSettings}>
    <Swiper
      modules={[Navigation, Pagination]}
      navigation={{
        nextEl: '.swiper-button-next.swiper-button-white',
        prevEl: '.swiper-button-prev.swiper-button-white',
      }}
      pagination={{ el: '.swiper-pagination', clickable: true }}
      loop
    >
      {list.map((item, idx) =>
        <SwiperSlide key={idx} className="lead-image" style={{ width: '1170px' }}>
          <Img src={item.image} variant="slider" />
          <Img src={item.image} variant="thumb" />
          {item.credits === '' ? '' : <span className="credits">{ item.credits }</span>}
        </SwiperSlide>)}
    </Swiper>
  </Container>
);

GalleryWidget.title = 'Gallery';
GalleryWidget.preview = 'gallery.png';
GalleryWidget.category = 'Content';

GalleryWidget.propTypes = {
  list: PropTypes.array.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

GalleryWidget.defaults = {
  list: [
    { id: 1, image: 'http://placehold.it/1920x568', credits: '© credits' },
    { id: 2, image: 'http://placehold.it/1920x568', credits: '© credits' },
    { id: 3, image: 'http://placehold.it/1920x568', credits: '© credits' },
  ],
  containerSettings: {},
};

const CarouselSlide = ({ settings, onChangeItem }) => (
  <div>
    <ImagePicker
      onChange={value => onChangeItem('image', value)}
      value={settings.image}
    />

    <TextInput
      label="Credits"
      onChange={value => onChangeItem('credits', value)}
      value={settings.credits}
    />
  </div>
);

CarouselSlide.propTypes = {
  settings: PropTypes.object.isRequired,
  onChangeItem: PropTypes.func.isRequired,
};

GalleryWidget.adminFields = (items, onChangeList) => (
  <List
    listItem={(settings, onChangeItem) =>
      <CarouselSlide settings={settings} onChangeItem={onChangeItem} />}
    onChangeList={onChangeList}
    items={items}
  />
);

export default GalleryWidget;
